import {FavoriteActions} from './types';
import {buildAsyncActionsCreator, createAsyncActionExecutor} from '../asyncUtils';
import {requestAddFavorite, requestGetFavoriteModelIds, requestRemoveFavorite} from './api';

export const favoriteAddActionsCreator = buildAsyncActionsCreator(FavoriteActions.ADD);
export const favoriteAdd = createAsyncActionExecutor(favoriteAddActionsCreator, requestAddFavorite);

export const favoriteRemoveActionsCreator = buildAsyncActionsCreator(FavoriteActions.REMOVE);
export const favoriteRemove = createAsyncActionExecutor(favoriteRemoveActionsCreator, requestRemoveFavorite);

export const favoriteFetchIdsActionsCreator = buildAsyncActionsCreator(FavoriteActions.FETCH_IDS);
export const favoriteFetchIds = createAsyncActionExecutor(favoriteFetchIdsActionsCreator, requestGetFavoriteModelIds);
